import { afterNextRender, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Toast } from 'primeng/toast';
import { APP_NAME } from './core/tokens/app-name.token';
import { InfoModalComponent } from "./shared/components/modal/info-modal/info-modal.component";
import { InactivityService } from './core/services/auth/inactivity.service';
import { NotificationHubService } from './core/services/notifications/notification-hub.service';
import { filter } from 'rxjs';

declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, InputTextModule, Toast, InfoModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  private readonly title = inject(Title);
  private readonly appName = inject(APP_NAME);
  private readonly inactivity = inject(InactivityService);
  private readonly hub = inject(NotificationHubService);
  private readonly router = inject(Router);
  
  readonly modalInfoLogoutId = 'info-logout-modal';
  readonly modalLogout = 'logout-modal';

  constructor () {
    this.title.setTitle(this.appName);

    afterNextRender(async () => {
      try {
        await this.hub.connect();
      } catch (err) {
        console.error('No se pudo conectar al NotificationHub:', err);
      }
    });
  }

  ngOnInit(): void {
    // GTM - Tracking de navegación SPA
    this.initGTMTracking();
  }

  private initGTMTracking(): void {
      window.dataLayer = window.dataLayer || [];
  
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          window.dataLayer.push({
            event: 'page_view',
            page_path: event.urlAfterRedirects,
          });
        });
    }
}
